import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Button } from '../../Button';

import { componentsTranslations } from '../../translations';

const withCancelAction = (WrappedComponent = () => null) => {
    const WithCancelAction = ({ buttonSize, cancelVariant, onCancel, ...others }) => (
        <Fragment>
            <Button color="secondary" className="text-uppercase" size={buttonSize} onClick={onCancel}>
                <FormattedMessage
                    {...{
                        noExit: componentsTranslations.ng_components_noExit,
                        close: componentsTranslations.ng_components_close,
                        cancel: componentsTranslations.ng_common_cancel
                    }[cancelVariant || 'cancel']}
                />
            </Button>
            <WrappedComponent buttonSize={buttonSize} {...others} />
        </Fragment>
    );

    WithCancelAction.propTypes = {
        buttonSize: PropTypes.string,
        cancelVariant: PropTypes.string,
        disabled: PropTypes.bool,
        onAdd: PropTypes.func,
        onCancel: PropTypes.func
    };

    WithCancelAction.displayName = 'WithCancelAction';

    return WithCancelAction;
};

export default withCancelAction;
